"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = __importDefault(require("react-jss"));
var LogoContent_styles_1 = __importDefault(require("./LogoContent.styles"));
var LogoContent = function (_a) {
    var classes = _a.classes, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.logoPath, logoPath = _c === void 0 ? '/static/img/logos/transavia-logo-stacked-green.svg' : _c, _d = _a.alt, alt = _d === void 0 ? 'Transavia Logo' : _d;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { src: logoPath, alt: alt }),
        react_1.default.createElement("span", { className: classes.text }, text)));
};
exports.default = react_jss_1.default(LogoContent_styles_1.default)(LogoContent);
//# sourceMappingURL=LogoContent.js.map